import '../../css/homepage.css';
import { render, showToast, showApiError, loadUserData } from '../main';
import { authApi } from '../api';
import { store } from '../state';
import { navigate } from '../router';
import { connect as connectSocket } from '../socket';
import { isAppleSignInAvailable, signInWithApple } from '../auth/apple-sign-in';
import {
  TOAST_CODE_INVALID,
  API_ERR_APPLE_SIGNIN,
  API_ERR_SEND_CODE,
} from '../utils/app-strings';

const logoUrl = new URL('../../images/logo/logo-white-256w.png', import.meta.url).href;
const logoTextUrl = new URL('../../images/logo-22questions/22questions-nobg-300w.png', import.meta.url).href;

// Card images (used by renderWelcome2)
const imgHappyCouple = new URL('../../images/card-images/happy-couple.jpg', import.meta.url).href;
const imgConnection = new URL('../../images/card-images/happy-couple-2.jpg', import.meta.url).href;
const imgCtaBackground = new URL('../../images/card-images/cta-background.jpg', import.meta.url).href;
const imgWhiteHearts = new URL('../../images/card-images/white-hearts.jpg', import.meta.url).href;

// Screenshots (used by sections 2, 7, 9)
const imgBrowseBy1 = new URL('../../images/screenshots/2026-02-17-browse-by-1.jpg', import.meta.url).href;
const imgBrowseBy3 = new URL('../../images/screenshots/2026-02-17-browse-by-3.jpg', import.meta.url).href;
const imgFilters1 = new URL('../../images/screenshots/2026-02-17-filters1.jpg', import.meta.url).href;
const imgProfiles1 = new URL('../../images/screenshots/2026-02-17-profiles1.jpg', import.meta.url).href;
const imgQa1 = new URL('../../images/screenshots/2026-02-17-qa1.jpg', import.meta.url).href;
const imgQa2 = new URL('../../images/screenshots/2026-02-17-qa2.jpg', import.meta.url).href;
const imgQa3 = new URL('../../images/screenshots/2026-02-17-qa3.jpg', import.meta.url).href;
const imgQa4 = new URL('../../images/screenshots/2026-02-17-qa4.jpg', import.meta.url).href;
const imgChatpacks1 = new URL('../../images/screenshots/2026-02-17-chatpacks1.jpg', import.meta.url).href;
const imgModeration1 = new URL('../../images/screenshots/2026-02-17-moderation1.jpg', import.meta.url).href;
const imgModeration2 = new URL('../../images/screenshots/2026-02-17-moderation2.jpg', import.meta.url).href;

// Background images - explicit imports for Parcel bundling
const bgImages: string[] = [
  new URL('../../images/bg/img001.jpg', import.meta.url).href,
  new URL('../../images/bg/img002.jpg', import.meta.url).href,
  new URL('../../images/bg/img003.jpg', import.meta.url).href,
  new URL('../../images/bg/img004.jpg', import.meta.url).href,
  new URL('../../images/bg/img005.jpg', import.meta.url).href,
  new URL('../../images/bg/img006.jpg', import.meta.url).href,
  new URL('../../images/bg/img007.jpg', import.meta.url).href,
  new URL('../../images/bg/img008.jpg', import.meta.url).href,
  new URL('../../images/bg/img009.jpg', import.meta.url).href,
  new URL('../../images/bg/img010.jpg', import.meta.url).href,
  new URL('../../images/bg/img011.jpg', import.meta.url).href,
  new URL('../../images/bg/img012.jpg', import.meta.url).href,
  new URL('../../images/bg/img013.jpg', import.meta.url).href,
  new URL('../../images/bg/img014.jpg', import.meta.url).href,
  new URL('../../images/bg/img015.jpg', import.meta.url).href,
  new URL('../../images/bg/img016.jpg', import.meta.url).href,
  new URL('../../images/bg/img017.jpg', import.meta.url).href,
  new URL('../../images/bg/img018.jpg', import.meta.url).href,
  new URL('../../images/bg/img019.jpg', import.meta.url).href,
  new URL('../../images/bg/img020.jpg', import.meta.url).href,
  new URL('../../images/bg/img021.jpg', import.meta.url).href,
  new URL('../../images/bg/img022.jpg', import.meta.url).href,
  new URL('../../images/bg/img023.jpg', import.meta.url).href,
  new URL('../../images/bg/img024.jpg', import.meta.url).href,
  new URL('../../images/bg/img025.jpg', import.meta.url).href,
  new URL('../../images/bg/img026.jpg', import.meta.url).href,
  new URL('../../images/bg/img027.jpg', import.meta.url).href,
  new URL('../../images/bg/img028.jpg', import.meta.url).href,
  new URL('../../images/bg/img029.jpg', import.meta.url).href,
  new URL('../../images/bg/img030.jpg', import.meta.url).href,
  new URL('../../images/bg/img031.jpg', import.meta.url).href,
  new URL('../../images/bg/img032.jpg', import.meta.url).href,
  new URL('../../images/bg/img033.jpg', import.meta.url).href,
  new URL('../../images/bg/img034.jpg', import.meta.url).href,
  new URL('../../images/bg/img035.jpg', import.meta.url).href,
  new URL('../../images/bg/img036.jpg', import.meta.url).href,
  new URL('../../images/bg/img037.jpg', import.meta.url).href,
  new URL('../../images/bg/img038.jpg', import.meta.url).href,
  new URL('../../images/bg/img039.jpg', import.meta.url).href,
  new URL('../../images/bg/img040.jpg', import.meta.url).href,
  new URL('../../images/bg/img041.jpg', import.meta.url).href,
  new URL('../../images/bg/img042.jpg', import.meta.url).href,
  new URL('../../images/bg/img043.jpg', import.meta.url).href,
  new URL('../../images/bg/img044.jpg', import.meta.url).href,
  new URL('../../images/bg/img045.jpg', import.meta.url).href,
  new URL('../../images/bg/img046.jpg', import.meta.url).href,
  new URL('../../images/bg/img047.jpg', import.meta.url).href,
  new URL('../../images/bg/img048.jpg', import.meta.url).href,
  new URL('../../images/bg/img049.jpg', import.meta.url).href,
  new URL('../../images/bg/img050.jpg', import.meta.url).href,
  new URL('../../images/bg/img051.jpg', import.meta.url).href,
  new URL('../../images/bg/img052.jpg', import.meta.url).href,
  new URL('../../images/bg/img053.jpg', import.meta.url).href,
  new URL('../../images/bg/img054.jpg', import.meta.url).href,
  new URL('../../images/bg/img055.jpg', import.meta.url).href,
  new URL('../../images/bg/img056.jpg', import.meta.url).href,
  new URL('../../images/bg/img057.jpg', import.meta.url).href,
  new URL('../../images/bg/img058.jpg', import.meta.url).href,
  new URL('../../images/bg/img059.jpg', import.meta.url).href,
  new URL('../../images/bg/img060.jpg', import.meta.url).href,
  new URL('../../images/bg/img061.jpg', import.meta.url).href,
  new URL('../../images/bg/img062.jpg', import.meta.url).href,
  new URL('../../images/bg/img063.jpg', import.meta.url).href,
  new URL('../../images/bg/img064.jpg', import.meta.url).href,
  new URL('../../images/bg/img065.jpg', import.meta.url).href,
  new URL('../../images/bg/img066.jpg', import.meta.url).href,
  new URL('../../images/bg/img067.jpg', import.meta.url).href,
  new URL('../../images/bg/img068.jpg', import.meta.url).href,
  new URL('../../images/bg/img069.jpg', import.meta.url).href,
  new URL('../../images/bg/img070.jpg', import.meta.url).href,
  new URL('../../images/bg/img071.jpg', import.meta.url).href,
  new URL('../../images/bg/img072.jpg', import.meta.url).href,
  new URL('../../images/bg/img073.jpg', import.meta.url).href,
  new URL('../../images/bg/img074.jpg', import.meta.url).href,
  new URL('../../images/bg/img075.jpg', import.meta.url).href,
  new URL('../../images/bg/img076.jpg', import.meta.url).href,
  new URL('../../images/bg/img077.jpg', import.meta.url).href,
  new URL('../../images/bg/img078.jpg', import.meta.url).href,
  new URL('../../images/bg/img079.jpg', import.meta.url).href,
  new URL('../../images/bg/img080.jpg', import.meta.url).href,
  new URL('../../images/bg/img081.jpg', import.meta.url).href,
  new URL('../../images/bg/img082.jpg', import.meta.url).href,
  new URL('../../images/bg/img083.jpg', import.meta.url).href,
  new URL('../../images/bg/img084.jpg', import.meta.url).href,
  new URL('../../images/bg/img085.jpg', import.meta.url).href,
  new URL('../../images/bg/img086.jpg', import.meta.url).href,
  new URL('../../images/bg/img087.jpg', import.meta.url).href,
  new URL('../../images/bg/img088.jpg', import.meta.url).href,
  new URL('../../images/bg/img089.jpg', import.meta.url).href,
  new URL('../../images/bg/img090.jpg', import.meta.url).href,
  new URL('../../images/bg/img091.jpg', import.meta.url).href,
  new URL('../../images/bg/img092.jpg', import.meta.url).href,
  new URL('../../images/bg/img093.jpg', import.meta.url).href,
  new URL('../../images/bg/img094.jpg', import.meta.url).href,
  new URL('../../images/bg/img095.jpg', import.meta.url).href,
  new URL('../../images/bg/img096.jpg', import.meta.url).href,
  new URL('../../images/bg/img097.jpg', import.meta.url).href,
  new URL('../../images/bg/img098.jpg', import.meta.url).href,
  new URL('../../images/bg/img099.jpg', import.meta.url).href,
  new URL('../../images/bg/img100.jpg', import.meta.url).href,
  new URL('../../images/bg/img101.jpg', import.meta.url).href,
  new URL('../../images/bg/img102.jpg', import.meta.url).href,
  new URL('../../images/bg/img103.jpg', import.meta.url).href,
  new URL('../../images/bg/img104.jpg', import.meta.url).href,
  new URL('../../images/bg/img105.jpg', import.meta.url).href,
  new URL('../../images/bg/img106.jpg', import.meta.url).href,
  new URL('../../images/bg/img107.jpg', import.meta.url).href,
  new URL('../../images/bg/img108.jpg', import.meta.url).href,
  new URL('../../images/bg/img109.jpg', import.meta.url).href,
  new URL('../../images/bg/img110.jpg', import.meta.url).href,
  new URL('../../images/bg/img111.jpg', import.meta.url).href,
  new URL('../../images/bg/img112.jpg', import.meta.url).href,
  new URL('../../images/bg/img113.jpg', import.meta.url).href,
  new URL('../../images/bg/img114.jpg', import.meta.url).href,
  new URL('../../images/bg/img115.jpg', import.meta.url).href,
  new URL('../../images/bg/img116.jpg', import.meta.url).href,
  new URL('../../images/bg/img117.jpg', import.meta.url).href,
  new URL('../../images/bg/img118.jpg', import.meta.url).href,
  new URL('../../images/bg/img119.jpg', import.meta.url).href,
  new URL('../../images/bg/img120.jpg', import.meta.url).href,
];

let resizeTimeout: number | null = null;
let shuffledImages: string[] = [];
let imageIndex = 0;
let tileInterval: number | null = null;
let screenshotInterval: number | null = null;

function shuffleArray<T>(array: T[]): T[] {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function getNextImage(): string {
  const img = shuffledImages[imageIndex];
  imageIndex = (imageIndex + 1) % shuffledImages.length;
  return img;
}

function handleResize(): void {
  // Debounce resize events
  if (resizeTimeout) {
    window.clearTimeout(resizeTimeout);
  }
  resizeTimeout = window.setTimeout(() => {
    // Only regenerate if we're on a homepage
    if (document.querySelector('.hp-content')) {
      injectTiledBackground();
    }
  }, 150);
}

function injectTiledBackground(): void {
  // Set up resize listener (only once)
  window.removeEventListener('resize', handleResize);
  window.addEventListener('resize', handleResize);

  // Clear existing interval
  if (tileInterval) {
    clearInterval(tileInterval);
    tileInterval = null;
  }

  // Remove existing grid if any
  document.querySelector('.hp-bg-grid')?.remove();

  // Shuffle images and reset index
  shuffledImages = shuffleArray(bgImages);
  imageIndex = 0;

  const maxWidth = 914;
  const gridWidth = Math.min(window.innerWidth, maxWidth);
  // Grid starts 60px down (below header), so visible height is viewport - 60
  const gridHeight = window.innerHeight - 60;

  // Calculate columns: at least 3, and enough so each tile is <= 250px
  const cols = Math.max(3, Math.ceil(gridWidth / 250));
  // Tile width fills grid exactly with no gaps
  const tileWidth = gridWidth / cols;
  const rows = Math.ceil(gridHeight / tileWidth);
  const totalTiles = cols * rows;

  // Calculate actual scrollbar width using a temporary element
  const scrollTest = document.createElement('div');
  scrollTest.style.cssText = 'width:100px;height:100px;overflow:scroll;position:absolute;top:-9999px';
  document.body.appendChild(scrollTest);
  const scrollbarWidth = scrollTest.offsetWidth - scrollTest.clientWidth;
  scrollTest.remove();

  // Create grid container
  const grid = document.createElement('div');
  grid.className = 'hp-bg-grid';
  grid.style.setProperty('--cols', String(cols));
  grid.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

  // Add tiles using shuffled images sequentially (no duplicates until we've used all 120)
  for (let i = 0; i < totalTiles; i++) {
    const img = document.createElement('img');
    img.src = getNextImage();
    img.alt = '';
    img.loading = 'lazy';
    grid.appendChild(img);
  }

  // Insert inside #app container
  const app = document.getElementById('app')!;
  app.insertBefore(grid, app.firstChild);

  // Track next flip target for preloading
  let nextTileIndex: number | null = null;
  let nextImageSrc: string | null = null;

  // Preload the first image to flip
  const preloadNext = () => {
    const gridEl = document.querySelector('.hp-bg-grid');
    if (!gridEl) return;
    const imgs = gridEl.querySelectorAll('img');
    if (imgs.length === 0) return;

    nextTileIndex = Math.floor(Math.random() * imgs.length);
    nextImageSrc = getNextImage();

    // Preload the image
    const preloader = new Image();
    preloader.src = nextImageSrc;
  };

  // Start preloading the first one
  preloadNext();

  // Start replacement timer - flip every second, image is preloaded 1s ahead
  tileInterval = window.setInterval(() => {
    const gridEl = document.querySelector('.hp-bg-grid');
    if (!gridEl) {
      // Grid removed, clear interval
      if (tileInterval) {
        clearInterval(tileInterval);
        tileInterval = null;
      }
      return;
    }
    const imgs = gridEl.querySelectorAll('img');
    if (imgs.length === 0) return;

    // Flip the preloaded tile
    if (nextTileIndex !== null && nextImageSrc !== null) {
      const img = imgs[nextTileIndex];
      const newSrc = nextImageSrc;

      // Start flip animation
      img.classList.add('flipping');

      // Change image at midpoint (300ms into 600ms animation)
      setTimeout(() => {
        img.src = newSrc;
      }, 300);

      // Remove class after animation completes
      setTimeout(() => {
        img.classList.remove('flipping');
      }, 600);
    }

    // Preload the next one for the following flip
    preloadNext();
  }, 3000);
}

function startScreenshotSwaps(): void {
  if (screenshotInterval) {
    clearInterval(screenshotInterval);
    screenshotInterval = null;
  }
  const containers = document.querySelectorAll('.hp-screenshot-swap');
  if (containers.length === 0) return;

  // Track current visible index per container (0 = base image, no overlay active)
  const indices = new Map<Element, number>();
  const dotSets = new Map<Element, HTMLElement[]>();

  containers.forEach(c => {
    const count = c.querySelectorAll('img').length;
    if (count < 2) return;
    indices.set(c, 0);

    // Create dot indicators below the swap container
    const dotsDiv = document.createElement('div');
    dotsDiv.className = 'hp-screenshot-dots';
    const dots: HTMLElement[] = [];
    for (let i = 0; i < count; i++) {
      const dot = document.createElement('span');
      dot.className = 'hp-screenshot-dot' + (i === 0 ? ' active' : '');
      dotsDiv.appendChild(dot);
      dots.push(dot);
    }
    c.appendChild(dotsDiv);
    dotSets.set(c, dots);
  });
  if (indices.size === 0) return;

  screenshotInterval = window.setInterval(() => {
    // If all containers are gone, stop
    if (!document.querySelector('.hp-screenshot-swap')) {
      clearInterval(screenshotInterval!);
      screenshotInterval = null;
      return;
    }

    indices.forEach((currentIdx, container) => {
      const imgs = container.querySelectorAll('img');
      const count = imgs.length;
      if (count < 2) return;

      const nextIdx = (currentIdx + 1) % count;
      const outgoing = currentIdx > 0 ? imgs[currentIdx] : null;
      const incoming = nextIdx > 0 ? imgs[nextIdx] : null;

      // Add .active to incoming overlay
      if (incoming) incoming.classList.add('active');

      // Remove .active from outgoing after crossfade completes
      if (outgoing) {
        const el = outgoing;
        setTimeout(() => el.classList.remove('active'), 600);
      }

      // Update dot indicators
      const dots = dotSets.get(container);
      if (dots) {
        dots[currentIdx].classList.remove('active');
        dots[nextIdx].classList.add('active');
      }

      indices.set(container, nextIdx);
    });
  }, 3000);
}

let currentEmail = '';
let isVerifyMode = false;
let isNewUserSignup = false;
let returnTo: 'login' | 'welcome' | 'welcome2' = 'login'; // Track which page to return to

function getAppleSignInHTML(): string {
  if (!isAppleSignInAvailable()) return '';
  return `
    <div class="apple-signin-divider">
      <span>or</span>
    </div>
    <button type="button" id="apple-signin-btn" class="apple-signin-btn">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.1 9.5c0-2.1 1.7-3.1 1.8-3.2-1-1.4-2.5-1.6-3.1-1.7-1.3-.1-2.5.8-3.2.8-.7 0-1.7-.7-2.8-.7-1.5 0-2.8.8-3.6 2.1-1.5 2.7-.4 6.6 1.1 8.7.7 1.1 1.6 2.2 2.7 2.2 1.1 0 1.5-.7 2.8-.7s1.7.7 2.8.7 1.9-1.1 2.6-2.1c.8-1.2 1.2-2.4 1.2-2.4 0-.1-2.3-.9-2.3-3.7zM10.9 3.3c.6-.7 1-1.7.9-2.7-0.9 0-1.9.6-2.5 1.3-.6.6-1 1.6-.9 2.6.9.1 1.9-.5 2.5-1.2z" fill="white"/>
      </svg>
      Sign in with Apple
    </button>
  `;
}

async function handleAppleSignIn(): Promise<void> {
  const btn = document.getElementById('apple-signin-btn') as HTMLButtonElement | null;
  if (!btn) return;

  btn.disabled = true;
  btn.textContent = 'Signing in...';

  try {
    const result = await signInWithApple();
    const response = await authApi.appleAuth({
      identityToken: result.identityToken,
      user: result.user,
      email: result.email,
      givenName: result.givenName,
      familyName: result.familyName,
    });

    const { accessToken, refreshToken, isNewUser } = response.data;
    store.setTokens(accessToken, refreshToken);

    const app = document.getElementById('app')!;
    app.className = '';
    document.documentElement.classList.remove('hp-active');
    document.body.classList.remove('hp-active');

    await loadUserData();
    connectSocket();
    import('../push').then(m => m.initPush()).catch(() => {});

    if (isNewUser) {
      navigate('/onboarding');
    } else {
      navigate('/browse');
    }
  } catch (err: any) {
    if (err?.message === 'Sign in cancelled') {
      // User cancelled - silently restore button
    } else {
      showApiError(err, API_ERR_APPLE_SIGNIN);
    }
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.1 9.5c0-2.1 1.7-3.1 1.8-3.2-1-1.4-2.5-1.6-3.1-1.7-1.3-.1-2.5.8-3.2.8-.7 0-1.7-.7-2.8-.7-1.5 0-2.8.8-3.6 2.1-1.5 2.7-.4 6.6 1.1 8.7.7 1.1 1.6 2.2 2.7 2.2 1.1 0 1.5-.7 2.8-.7s1.7.7 2.8.7 1.9-1.1 2.6-2.1c.8-1.2 1.2-2.4 1.2-2.4 0-.1-2.3-.9-2.3-3.7zM10.9 3.3c.6-.7 1-1.7.9-2.7-0.9 0-1.9.6-2.5 1.3-.6.6-1 1.6-.9 2.6.9.1 1.9-.5 2.5-1.2z" fill="white"/>
        </svg>
        Sign in with Apple
      `;
    }
  }
}

function attachAppleSignInHandler(): void {
  const btn = document.getElementById('apple-signin-btn');
  btn?.addEventListener('click', handleAppleSignIn);
}

// Simple login page
export function renderLogin(): void {
  if (isVerifyMode) {
    renderVerifyCode();
    return;
  }

  const app = document.getElementById('app')!;
  app.className = 'hp-page';
  document.documentElement.classList.add('hp-active');
  document.body.classList.add('hp-active');

  render(`
    <!-- Navigation -->
    <nav class="hp-nav">
      <a href="#/welcome" class="hp-nav-logo">
        <img src="${logoTextUrl}" alt="22 Questions" class="hp-nav-logo-img">
      </a>
      <div class="hp-nav-inner"></div>
    </nav>

    <!-- Scrollable Content -->
    <div class="hp-content">
    <!-- Login Content -->
    <section class="hp-section hp-hero">
      <div class="hp-section-inner">
        <div class="hp-section-card">
          <div class="hp-centered" style="padding: 2rem 0;">
            <h1 class="hp-headline" style="margin-bottom: 1rem;">Sign In</h1>
            <p class="hp-subhead" style="margin-bottom: 2rem;">
              Enter your email address to sign in or create a new account.
            </p>

            <form id="login-email-form" action="/login" method="post" class="hp-cta-form" style="max-width: 400px; margin: 0 auto;">
              <input type="email" id="login-email" name="email" class="input" placeholder="Enter your email" inputmode="email" autocomplete="username" autocapitalize="off" required>
              <button type="submit" class="btn btn-primary">Sign In</button>
            </form>
            <p class="hp-small" style="margin-top: 1rem;">We'll send you a 6-digit code to verify your email.</p>
            ${getAppleSignInHTML()}
          </div>
        </div>
      </div>
    </section>
    </div><!-- /.hp-content -->
  `, false);

  injectTiledBackground();
  attachAppleSignInHandler();

  // Attach form handler
  const form = document.getElementById('login-email-form')!

  form.addEventListener('submit', async (e: Event) => {
    e.preventDefault();
    const input = form.querySelector('input[type="email"]') as HTMLInputElement;
    const btn = form.querySelector('button') as HTMLButtonElement;
    const email = input.value.trim();
    if (!email) return;

    btn.disabled = true;
    btn.textContent = 'Sending...';

    try {
      const res = await authApi.requestCode(email);
      currentEmail = email;
      isNewUserSignup = res.data.isNewUser;
      isVerifyMode = true;
      returnTo = 'login';
      renderVerifyCode();
    } catch (err: any) {
      showApiError(err, API_ERR_SEND_CODE);
      btn.disabled = false;
      btn.textContent = 'Sign In';
    }
  });
}

// Full welcome/marketing page
export function renderWelcome(): void {
  if (isVerifyMode) {
    renderVerifyCode();
    return;
  }

  const app = document.getElementById('app')!;
  app.className = 'hp-page';
  document.documentElement.classList.add('hp-active');
  document.body.classList.add('hp-active');

  const isLoggedIn = !!store.getState().accessToken;

  render(`
    <!-- Navigation -->
    <nav class="hp-nav">
      <a href="#/welcome" class="hp-nav-logo">
        <img src="${logoTextUrl}" alt="22 Questions" class="hp-nav-logo-img">
      </a>
      <div class="hp-nav-inner">
        <a href="#/compare" class="hp-nav-link">Compare</a>
        ${isLoggedIn
          ? '<a href="#/about-me" class="btn btn-primary btn-sm">My Account</a>'
          : '<button type="button" id="nav-signin-btn" class="btn btn-primary btn-sm">Sign In</button>'
        }
      </div>
    </nav>

    <!-- Scrollable Content -->
    <div class="hp-content">

    <!-- 1. Hero (CTA #1) — plain -->
    <section class="hp-section hp-hero">
      <div class="hp-section-inner">
        <div class="hp-section-card">
          <div class="hp-centered">
            <p class="hp-hero-tagline" style="font-weight: var(--weight-bold); color: var(--primary);">Every feature. Every filter. Free.</p>
            <h1 class="hp-hero-title">
              Dating apps are <span class="highlight">broken on purpose</span>.
            </h1>
            <p class="hp-hero-subtitle">
              Other apps hide your matches behind paywalls.
              They bury your profile unless you pay.
              They charge $90/month and it still doesn&rsquo;t work.<br>
              <strong>We built one that actually does.</strong>
            </p>

            <form id="hero-email-form" action="" method="post" class="hp-cta-form" style="margin: 0 auto;">
              <input type="email" id="hero-email" name="email" class="input" placeholder="Enter your email" inputmode="email" autocomplete="email" autocapitalize="off" required>
              <button type="submit" class="btn btn-primary">Get Started</button>
            </form>
            <p class="hp-cta-hint">Free. All features. No paywalls.</p>
            ${getAppleSignInHTML()}
          </div>
        </div>
      </div>
    </section>

    <!-- 2. Core Position — plain -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card">
          <div class="hp-split">
            <div class="hp-split-text">
              <h2 class="hp-headline">Swipe or browse. Your choice.</h2>
              <p class="hp-body" style="margin-bottom: 1.5rem;">
                We want to help you find someone, not keep you on the app.
              </p>
              <ul class="hp-list hp-list--check">
                <li>55+ filters, 10+ sort options</li>
                <li>Only see people whose preferences match yours too</li>
                <li>Up to 100 photos (Bumble allows 6)</li>
                <li>Matches never expire. No timers.</li>
                <li>Unlimited likes. Free.</li>
              </ul>
            </div>
            <div class="hp-screenshot-swap">
              <img src="${imgBrowseBy1}" alt="Grid browse view" />
              <img src="${imgBrowseBy3}" alt="Column browse view" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 3. The Problem — dark -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--dark">
          <div class="hp-centered">
            <h2 class="hp-headline">The idea of online dating isn&rsquo;t broken.</h2>
            <p class="hp-subhead" style="margin-bottom: 2rem;"><strong>The current dating apps are broken.</strong></p>

            <p class="hp-body" style="margin-bottom: 2rem; opacity: 0.9;">
              They make money when you stay single.<br>
              If you find someone quickly, they lose a customer.
            </p>

            <div style="margin-top: 0.5rem; padding: 1.5rem; background: var(--primary); border-radius: var(--radius);">
              <div style="display: flex; justify-content: center;">
                <ul class="hp-list hp-list--white">
                  <li style="color: #fff;">They hide your best matches behind paywalls</li>
                  <li style="color: #fff;">They bury your profile unless you pay</li>
                  <li style="color: #fff;">They charge $90/month. It still doesn&rsquo;t work.</li>
                </ul>
              </div>
              <p class="hp-body" style="margin-top: 1.5rem; font-weight: var(--weight-semibold); color: #fff;">
                That&rsquo;s not a bug. That&rsquo;s how they make money.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 4. What We Removed — accent -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--accent">
          <div class="hp-split hp-split--reverse">
            <div class="hp-split-text">
              <h2 class="hp-headline" style="color: #fff;">None of this exists here</h2>
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0 0.5rem; margin: 2rem 0; max-width: 500px;">
                <ul class="hp-list hp-list--x" style="margin: 0;">
                  <li style="color: #fff;">No subscriptions</li>
                  <li style="color: #fff;">No ads</li>
                  <li style="color: #fff;">No boosts</li>
                  <li style="color: #fff;">No Super Likes</li>
                  <li style="color: #fff;">No hidden likes</li>
                  <li style="color: #fff;">No pay to be seen</li>
                  <li style="color: #fff;">No bots</li>
                </ul>
                <ul class="hp-list hp-list--x" style="margin: 0;">
                  <li style="color: #fff;">No fake scarcity</li>
                  <li style="color: #fff;">No paid rewinds</li>
                  <li style="color: #fff;">No match expirations</li>
                  <li style="color: #fff;">No like limits</li>
                  <li style="color: #fff;">No messaging limits</li>
                  <li style="color: #fff;">No spam accounts</li>
                </ul>
              </div>
              <p class="hp-body" style="color: #fff; margin-top: 2rem; font-size: var(--text-subhead);">
                You don&rsquo;t pay to exist.<br>
                You don&rsquo;t pay to be seen.<br>
                You don&rsquo;t pay to find your best match.
              </p>
            </div>
            <div class="hp-screenshot-swap">
              <img src="${imgProfiles1}" alt="Profile view" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 5. Product Features — plain -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card">
          <div class="hp-centered">
            <h2 class="hp-headline">We offer everything they have for free.<br>Plus more.</h2>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem 2rem; margin: 2rem auto; max-width: 600px;">
              <div>
                <p class="hp-body" style="font-weight: var(--weight-bold); margin-bottom: 0.5rem;">Search &amp; Discovery</p>
                <ul class="hp-list hp-list--check">
                  <li>55+ filters</li>
                  <li>10+ sort options</li>
                  <li>Only see people who also match your preferences</li>
                  <li>Grid browse or swipe</li>
                </ul>
              </div>
              <div>
                <p class="hp-body" style="font-weight: var(--weight-bold); margin-bottom: 0.5rem;">Profiles &amp; Visibility</p>
                <ul class="hp-list hp-list--check">
                  <li>Up to 100 photos</li>
                  <li>Control exactly what people see on your profile</li>
                  <li>Chat Packs Q&amp;A</li>
                  <li>"Prefer not to answer" on every field</li>
                </ul>
              </div>
              <div>
                <p class="hp-body" style="font-weight: var(--weight-bold); margin-bottom: 0.5rem;">Matches &amp; Likes</p>
                <ul class="hp-list hp-list--check">
                  <li>Unlimited likes</li>
                  <li>See who liked you</li>
                  <li>No expirations</li>
                  <li>No timers</li>
                </ul>
              </div>
              <div>
                <p class="hp-body" style="font-weight: var(--weight-bold); margin-bottom: 0.5rem;">Privacy &amp; Control</p>
                <ul class="hp-list hp-list--check">
                  <li>Incognito mode</li>
                  <li>Travel mode</li>
                  <li>No phone number required</li>
                  <li>Blocking &amp; reporting</li>
                </ul>
              </div>
            </div>
            <p class="hp-body" style="font-weight: var(--weight-semibold); margin-top: 1.5rem; font-size: var(--text-subhead);">
              All of it. Free. No asterisks.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 6. Mid CTA #2 — dark -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--dark">
          <div class="hp-centered">
            <h2 class="hp-headline" style="margin-bottom: 1.5rem;">Ready to try it?</h2>
            <form id="mid-email-form-1" action="" method="post" class="hp-cta-form" style="margin: 0 auto;">
              <input type="email" name="email" class="input" placeholder="Enter your email" inputmode="email" autocomplete="email" autocapitalize="off" required>
              <button type="submit" class="btn btn-primary">Get Started</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- 7. Q&A / Chat Packs — plain -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card">
          <div class="hp-split hp-split--reverse">
            <div class="hp-split-text">
              <h2 class="hp-headline">Answer once. Share your answers with every match.</h2>
              <p class="hp-body" style="margin-top: 1.5rem;">
                Escape endless text chats.
              </p>
              <p class="hp-body" style="margin-top: 1rem;">
                No more repeating the same small talk.
              </p>
            </div>
            <div class="hp-screenshot-swap">
              <img src="${imgQa1}" alt="Chat Packs Q&amp;A view" />
              <img src="${imgQa2}" alt="Chat Packs answer comparison" />
              <img src="${imgQa3}" alt="Chat Packs question detail" />
              <img src="${imgQa4}" alt="Chat Packs shared answers" />
              <img src="${imgChatpacks1}" alt="Chat Packs overview" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 8. Comparison vs Bumble — accent -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--accent">
          <div class="hp-centered">
            <h2 class="hp-headline" style="color: #fff;">See what free actually looks like.</h2>
            <p class="hp-subhead" style="color: #fff; margin-bottom: 2rem;">22 Questions vs. Bumble</p>
            <div style="display: grid; grid-template-columns: 1fr auto auto; column-gap: 1px; max-width: 420px; margin: 0 auto; text-align: left; border-radius: var(--radius); overflow: hidden; border: 1px solid rgba(255,255,255,0.25); font-size: var(--text-small);">
              <div style="padding: 0.5rem 0.5rem 0.5rem 0.75rem; background: rgba(0,0,0,0.5); border-bottom: 2px solid rgba(255,255,255,0.4); font-weight: var(--weight-bold); color: #fff; text-transform: uppercase; letter-spacing: 0.05em;">Feature</div>
              <div style="padding: 0.5rem 0.75rem; background: rgba(0,0,0,0.5); border-bottom: 2px solid rgba(255,255,255,0.4); font-weight: var(--weight-bold); color: #fff; text-transform: uppercase; letter-spacing: 0.05em; text-align: center;">22Q</div>
              <div style="padding: 0.5rem 0.75rem 0.5rem 0.5rem; background: rgba(0,0,0,0.5); border-bottom: 2px solid rgba(255,255,255,0.4); font-weight: var(--weight-bold); color: rgba(255,255,255,0.6); text-transform: uppercase; letter-spacing: 0.05em; text-align: center;">Bumble</div>

              <div style="padding: 0.5rem 0.25rem 0.5rem 0.75rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: rgba(255,255,255,0.85);">All filters &amp; search</div>
              <div style="padding: 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; font-weight: var(--weight-bold); text-align: center;">Free</div>
              <div style="padding: 0.5rem 0.75rem 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; text-align: center;">$60&ndash;90/mo</div>

              <div style="padding: 0.5rem 0.25rem 0.5rem 0.75rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: rgba(255,255,255,0.85);">See who liked you</div>
              <div style="padding: 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; font-weight: var(--weight-bold); text-align: center;">Free</div>
              <div style="padding: 0.5rem 0.75rem 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; text-align: center;">$60&ndash;90/mo</div>

              <div style="padding: 0.5rem 0.25rem 0.5rem 0.75rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: rgba(255,255,255,0.85);">Sort &amp; browse freely</div>
              <div style="padding: 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; font-weight: var(--weight-bold); text-align: center;">Free</div>
              <div style="padding: 0.5rem 0.75rem 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; text-align: center;">N/A</div>

              <div style="padding: 0.5rem 0.25rem 0.5rem 0.75rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: rgba(255,255,255,0.85);">Photos</div>
              <div style="padding: 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; font-weight: var(--weight-bold); text-align: center;">100</div>
              <div style="padding: 0.5rem 0.75rem 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; text-align: center;">6</div>

              <div style="padding: 0.5rem 0.25rem 0.5rem 0.75rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: rgba(255,255,255,0.85);">AI safety moderation</div>
              <div style="padding: 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; font-weight: var(--weight-bold); text-align: center;">Free</div>
              <div style="padding: 0.5rem 0.75rem 0.5rem 0.25rem; border-bottom: 1px solid rgba(255,255,255,0.25); color: #fff; text-align: center;">None</div>

              <div style="padding: 0.5rem 0.25rem 0.5rem 0.75rem; color: rgba(255,255,255,0.85);">Boosts &amp; SuperSwipes</div>
              <div style="padding: 0.5rem 0.25rem; color: #fff; font-weight: var(--weight-bold); text-align: center;">Nope!</div>
              <div style="padding: 0.5rem 0.75rem 0.5rem 0.25rem; color: #fff; text-align: center;">$60/30 pack</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 9. Safety — dark -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--dark">
          <div class="hp-split">
            <div class="hp-split-text">
              <h2 class="hp-headline">Safe by design.<br>Not safe by subscription.</h2>
              <div style="max-width: 500px; text-align: left;">
                <p class="hp-body" style="margin-bottom: 1.5rem;">
                  <strong style="color: #fff;">AI moderation on every message and image.</strong><br>
                  <span style="opacity: 0.7;">Real-time. Not after someone reports it.</span>
                </p>
                <p class="hp-body" style="margin-bottom: 1.5rem;">
                  <strong style="color: #fff;">You choose whether to receive images.</strong><br>
                  <span style="opacity: 0.7;">No unwanted photos. Ever.</span>
                </p>
                <p class="hp-body" style="margin-bottom: 1.5rem;">
                  <strong style="color: #fff;">No bots. No spam accounts.</strong><br>
                  <span style="opacity: 0.7;">Other apps benefit from fake accounts. We don&rsquo;t.</span>
                </p>
                <p class="hp-body">
                  <strong style="color: #fff;">Never give out your phone number.</strong><br>
                  <span style="opacity: 0.7;">Chat in-app. Full blocking and reporting.</span>
                </p>
              </div>
            </div>
            <div class="hp-screenshot-swap">
              <img src="${imgModeration1}" class="hp-screenshot-swap-img" alt="AI moderation rejecting an inappropriate text message" />
              <img src="${imgModeration2}" class="hp-screenshot-swap-img" alt="AI moderation rejecting an inappropriate image" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 10. Mid CTA #3 — accent -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--accent">
          <div class="hp-centered">
            <h2 class="hp-headline" style="color: #fff; margin-bottom: 1.5rem;">Free.<br>Full-featured.<br>Try it.</h2>
            <form id="mid-email-form-2" action="" method="post" class="hp-cta-form" style="margin: 0 auto;">
              <input type="email" name="email" class="input" placeholder="Enter your email" inputmode="email" autocomplete="email" autocapitalize="off" required>
              <button type="submit" class="btn" style="background: #fff; color: var(--primary); font-weight: var(--weight-semibold); padding: 1rem 2rem; font-size: var(--text-body); border-radius: var(--radius-pill);">Get Started</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- 11. Business Model — gradient -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--gradient">
          <div class="hp-centered">
            <h2 class="hp-headline">How we make money (and how we don&rsquo;t)</h2>

            <div class="hp-card" style="max-width: 500px; margin: 1.5rem auto 0;">
              <div style="display: flex; justify-content: center;">
                <ul class="hp-list hp-list--check">
                  <li>The dating app is completely free</li>
                  <li>AI safety is always free</li>
                  <li>Optional AI features (like image generation) cost a few cents each</li>
                  <li>We ask you to tip <strong style="color: var(--primary); font-size: var(--text-heading);">$5</strong> after you&rsquo;ve had a great first date</li>
                </ul>
              </div>
              <p class="hp-body" style="margin-top: 1.5rem;">
                That&rsquo;s the model. No tricks.
              </p>
            </div>

            <div style="margin-top: 2rem;">
              <p class="hp-body" style="font-weight: var(--weight-semibold); margin-bottom: 0.5rem;">Why this works now</p>
              <p class="hp-body" style="opacity: 0.85;">
                Servers are cheaper now.<br>
                Software is cheaper to build now.<br>
                AI can handle moderation for pennies.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 12. Who This Is For — plain -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card">
          <div class="hp-centered">
            <h2 class="hp-headline">This app is for people who:</h2>
            <div style="display: flex; justify-content: center; margin: 2rem 0;">
              <ul class="hp-list hp-list--check">
                <li>Are tired of paying to be seen</li>
                <li>Want to actually find someone</li>
                <li>Want real profiles, not highlight reels</li>
                <li>Want safety built in, not sold separately</li>
                <li>Are done with apps that break things on purpose</li>
              </ul>
            </div>
            <p class="hp-body" style="margin-bottom: 1rem;">
              Every orientation, relationship style, and configuration. No separate apps. No judgment.
            </p>
            <p class="hp-body" style="color: var(--text-muted);">
              If you like dopamine loops and pay-to-play games, there are plenty of other apps.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 13. Final CTA #4 — accent -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--accent">
          <div class="hp-centered">
            <h2 class="hp-headline" style="color: #fff; margin-bottom: 1rem;">
              Try it. It&rsquo;s free.
            </h2>
            <p class="hp-subhead" style="color: #fff; margin-bottom: 2rem;">
              Built by one person who thinks dating apps can actually work.
            </p>
            <form id="footer-email-form" action="" method="post" class="hp-cta-form" style="margin: 0 auto;">
              <input type="email" id="footer-email" name="email" class="input" placeholder="Enter your email" inputmode="email" autocomplete="email" autocapitalize="off" required>
              <button type="submit" class="btn" style="background: #fff; color: var(--primary); font-weight: var(--weight-semibold); padding: 1rem 2rem; font-size: var(--text-body); border-radius: var(--radius-pill);">Get Started</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="hp-footer">
      <div class="hp-footer-inner">
        <div class="hp-footer-logo">
          <img src="${logoTextUrl}" alt="22 Questions" class="hp-footer-logo-img">
        </div>
        <p class="hp-footer-text">
          Independent. No Match Group. No Bumble Inc. No venture capital telling us to extract more money from you.
        </p>
        <div class="hp-footer-legal">
          <a href="#/privacy">Privacy Policy</a>
          <span class="hp-footer-divider">|</span>
          <a href="#/terms">Terms of Service</a>
          <span class="hp-footer-divider">|</span>
          <a href="#/contact">Contact</a>
        </div>
      </div>
    </footer>
    </div><!-- /.hp-content -->
  `, false);

  injectTiledBackground();
  startScreenshotSwaps();

  // Attach form handlers
  const heroForm = document.getElementById('hero-email-form')!;
  const footerForm = document.getElementById('footer-email-form')!;
  const midForm1 = document.getElementById('mid-email-form-1')!;
  const midForm2 = document.getElementById('mid-email-form-2')!;
  const navSigninBtn = document.getElementById('nav-signin-btn');

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const input = form.querySelector('input[type="email"]') as HTMLInputElement;
    const btn = form.querySelector('button') as HTMLButtonElement;
    const email = input.value.trim();
    if (!email) return;

    btn.disabled = true;
    btn.textContent = 'Sending...';

    try {
      const res = await authApi.requestCode(email);
      currentEmail = email;
      isNewUserSignup = res.data.isNewUser;
      isVerifyMode = true;
      returnTo = 'welcome';
      renderVerifyCode();
    } catch (err: any) {
      showApiError(err, API_ERR_SEND_CODE);
      btn.disabled = false;
      btn.textContent = 'Get Started';
    }
  };

  heroForm.addEventListener('submit', handleSubmit);
  footerForm.addEventListener('submit', handleSubmit);
  midForm1.addEventListener('submit', handleSubmit);
  midForm2.addEventListener('submit', handleSubmit);
  attachAppleSignInHandler();

  // Nav sign in goes to login page (only when not logged in)
  navSigninBtn?.addEventListener('click', () => {
    navigate('/login');
  });
}

// Welcome2 landing page - rewritten marketing copy, same design system
export function renderWelcome2(): void {
  if (isVerifyMode) {
    renderVerifyCode();
    return;
  }

  const app = document.getElementById('app')!;
  app.className = 'hp-page';
  document.documentElement.classList.add('hp-active');
  document.body.classList.add('hp-active');

  const isLoggedIn = !!store.getState().accessToken;

  render(`
    <!-- Navigation -->
    <nav class="hp-nav">
      <a href="#/welcome2" class="hp-nav-logo">
        <img src="${logoTextUrl}" alt="22 Questions" class="hp-nav-logo-img">
      </a>
      <div class="hp-nav-inner">
        <a href="#/compare" class="hp-nav-link">Compare</a>
        ${isLoggedIn
          ? '<a href="#/about-me" class="btn btn-primary btn-sm">My Account</a>'
          : '<button type="button" id="nav-signin-btn" class="btn btn-primary btn-sm">Sign In</button>'
        }
      </div>
    </nav>

    <!-- Scrollable Content -->
    <div class="hp-content">
    <!-- Section 1: Hero -->
    <section class="hp-section hp-hero">
      <div class="hp-section-inner">
        <div class="hp-section-card">
          <div class="hp-hero-content">
            <div class="hp-hero-text">
              <p class="hp-hero-tagline" style="font-weight: var(--weight-bold);">Dating without the games.</p>
              <h1 class="hp-hero-title">
                Meet people. <span class="highlight">Not paywalls.</span>
              </h1>
              <p class="hp-hero-subtitle">
                A free dating app where nobody is hidden, nothing is locked, and we only get paid when you have a great first date.
              </p>

              <form id="hero-email-form" action="" method="post" class="hp-cta-form">
                <input type="email" id="hero-email" name="email" class="input" placeholder="Enter your email" inputmode="email" autocomplete="email" autocapitalize="off" required>
                <button type="submit" class="btn btn-primary">Get Started</button>
              </form>
              <p class="hp-cta-hint">Free. All features. No paywalls.</p>
              ${getAppleSignInHTML()}
            </div>

            <div class="hp-hero-image">
              <img src="${imgHappyCouple}" alt="Happy couple">
              <div class="hp-image-overlay">
                <span class="hp-image-text">No Algorithms.<br>No Tricks.<br><span style="font-size: var(--text-subhead); font-weight: var(--weight-normal);">(Just People.)</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 2: The Insight -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--dark">
          <div class="hp-centered">
            <h2 class="hp-headline">If you find someone quickly, they lose a customer.</h2>
            <p class="hp-body" style="margin-top: 1.5rem; opacity: 0.9;">
              Blurred likes you have to pay to see. Profiles hidden unless you subscribe.
              Boosts that sell you visibility that should have been free.
              These aren't flaws - they're revenue streams.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 3: The Proof -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--accent">
          <div class="hp-centered">
            <h2 class="hp-headline" style="color: #fff;">Everything is free. Everything is unlimited.</h2>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0 0.5rem; margin: 2rem auto; max-width: 500px;">
              <ul class="hp-list hp-list--x" style="margin: 0;">
                <li style="color: #fff;">No subscriptions</li>
                <li style="color: #fff;">No ads</li>
                <li style="color: #fff;">No boosts</li>
                <li style="color: #fff;">No Super Likes</li>
                <li style="color: #fff;">No hidden likes</li>
                <li style="color: #fff;">No pay to be seen</li>
              </ul>
              <ul class="hp-list hp-list--x" style="margin: 0;">
                <li style="color: #fff;">No fake scarcity</li>
                <li style="color: #fff;">No paid rewinds</li>
                <li style="color: #fff;">No match expirations</li>
                <li style="color: #fff;">No like limits</li>
                <li style="color: #fff;">No messaging limits</li>
              </ul>
            </div>
            <p class="hp-body" style="color: #fff; margin-top: 2rem; font-size: var(--text-subhead);">
              You don't pay to exist.<br>
              You don't pay to be visible.<br>
              You don't pay to undo damage we created.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 4: The Business Model -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card hp-section-card--gradient">
          <div class="hp-centered">
            <h2 class="hp-headline">We only get paid when it works.</h2>

            <div class="hp-card" style="max-width: 500px; margin: 1.5rem auto 0;">
              <div style="display: flex; justify-content: center;">
                <ul class="hp-list hp-list--check">
                  <li>The app is completely free to use</li>
                  <li>No features are locked</li>
                  <li>No outcomes are influenced by payment</li>
                </ul>
              </div>
              <p class="hp-body" style="margin-top: 1.5rem;">
                If our app helps you have a great first date,<br>
                you can choose to tip <strong style="color: var(--primary); font-size: var(--text-heading);">$5</strong>.
              </p>
              <p class="hp-body" style="margin-top: 1rem;">
                If it doesn't help, you pay <strong>nothing</strong>.
              </p>
            </div>

            <p class="hp-body" style="margin-top: 1.5rem; font-weight: var(--weight-semibold);">
              Subscription apps get paid whether they help you or not. We don't.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 5: Who It's For -->
    <section class="hp-section hp-final-cta">
      <div class="hp-section-inner">
        <div class="hp-section-card" style="background-image: url('${imgWhiteHearts}');">
          <div class="hp-centered">
            <h2 class="hp-headline">Built for people who want online dating to actually work.</h2>
            <div style="display: flex; justify-content: center; margin: 2rem 0;">
              <ul class="hp-list hp-list--check">
                <li>Believe relationships matter</li>
                <li>Tired of being manipulated</li>
                <li>Want to meet someone without paying for visibility</li>
                <li>Ready to try something different</li>
              </ul>
            </div>
            <p class="hp-body" style="color: var(--text-muted); margin-top: 2rem;">
              If you've ever wondered why dating apps feel like they're working against you - they are.
              This is the alternative.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 6: The Product -->
    <section class="hp-section">
      <div class="hp-section-inner">
        <div class="hp-section-card">
          <div class="hp-split">
            <div class="hp-split-image">
              <img src="${imgConnection}" alt="Connection">
              <div class="hp-image-overlay">
                <span class="hp-image-text">Real dating app.<br>No compromises.</span>
              </div>
            </div>
            <div class="hp-split-text">
              <h2 class="hp-headline" style="margin-bottom: 1rem;">A real dating app. Not a stripped-down protest.</h2>
              <p class="hp-body" style="margin-bottom: 1rem;">
                Profiles, discovery, matching, messaging, filters, safety tools. Everything works. Nothing is locked.
              </p>
              <p class="hp-body">
                <strong>The difference is what we refuse to do to you.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 7: Final CTA -->
    <section class="hp-section hp-final-cta">
      <div class="hp-section-inner">
        <div class="hp-section-card" style="background-image: url('${imgCtaBackground}');">
          <div class="hp-centered">
            <h2 class="hp-headline" style="margin-bottom: 1rem;">
              Try a dating app that only succeeds when you do.
            </h2>
            <p class="hp-subhead" style="margin-bottom: 2rem;">
              Free to join. Free to use. And if it doesn't work, free to leave - because you never paid in the first place.
            </p>
            <form id="footer-email-form" action="" method="post" class="hp-cta-form" style="margin: 0 auto;">
              <input type="email" id="footer-email" name="email" class="input" placeholder="Enter your email" inputmode="email" autocomplete="email" autocapitalize="off" required>
              <button type="submit" class="btn btn-primary">Get Started</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="hp-footer">
      <div class="hp-footer-inner">
        <div class="hp-footer-logo">
          <img src="${logoTextUrl}" alt="22 Questions" class="hp-footer-logo-img">
        </div>
        <p class="hp-footer-text">
          Independent. No Match Group. No Bumble Inc. No venture mandate to monetize users.
        </p>
        <div class="hp-footer-legal">
          <a href="#/privacy">Privacy Policy</a>
          <span class="hp-footer-divider">|</span>
          <a href="#/terms">Terms of Service</a>
          <span class="hp-footer-divider">|</span>
          <a href="#/contact">Contact</a>
        </div>
      </div>
    </footer>
    </div><!-- /.hp-content -->
  `, false);

  injectTiledBackground();

  // Attach form handlers
  const heroForm = document.getElementById('hero-email-form')!;
  const footerForm = document.getElementById('footer-email-form')!;
  const navSigninBtn = document.getElementById('nav-signin-btn');

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const input = form.querySelector('input[type="email"]') as HTMLInputElement;
    const btn = form.querySelector('button') as HTMLButtonElement;
    const email = input.value.trim();
    if (!email) return;

    btn.disabled = true;
    btn.textContent = 'Sending...';

    try {
      const res = await authApi.requestCode(email);
      currentEmail = email;
      isNewUserSignup = res.data.isNewUser;
      isVerifyMode = true;
      returnTo = 'welcome2';
      renderVerifyCode();
    } catch (err: any) {
      showApiError(err, API_ERR_SEND_CODE);
      btn.disabled = false;
      btn.textContent = 'Get Started';
    }
  };

  heroForm.addEventListener('submit', handleSubmit);
  footerForm.addEventListener('submit', handleSubmit);
  attachAppleSignInHandler();

  // Nav sign in goes to login page (only when not logged in)
  navSigninBtn?.addEventListener('click', () => {
    navigate('/login');
  });
}

function renderVerifyCode(): void {
  const app = document.getElementById('app')!;
  app.className = '';
  document.documentElement.classList.remove('hp-active');
  document.body.classList.remove('hp-active');

  const welcomeText = isNewUserSignup
    ? 'Welcome!<br><br>Creating new account.'
    : 'Welcome back!';

  render(`
    <div class="login-container">
      <h1 class="login-title" style="font-size: var(--text-heading);">${welcomeText}</h1>
      <h2 class="login-title" style="font-size: var(--text-heading);">Check your email</h2>
      <p class="login-subtitle" style="margin-top: 0.5rem;">We sent a code to ${currentEmail}</p>

      <form id="verify-form" class="login-form" style="text-align: center;">
        <div class="input-group mb-2">
          <label for="code">6-digit code</label>
          <input
            type="text"
            id="code"
            class="input code-input"
            placeholder="000000"
            maxlength="6"
            pattern="[0-9]{6}"
            inputmode="numeric"
            autocomplete="one-time-code"
            required
          />
        </div>
        <button type="submit" class="btn btn-primary btn-large" style="width: fit-content; min-width: 15rem;">
          Verify
        </button>
      </form>

      <button id="back-btn" class="btn btn-secondary btn-large mt-2" style="width: fit-content; min-width: 15rem;">
        Use Different Email
      </button>
    </div>
  `, false);

  const form = document.getElementById('verify-form')!;
  const codeInput = document.getElementById('code') as HTMLInputElement;
  const backBtn = document.getElementById('back-btn')!;

  // Auto-submit when 6 digits entered
  codeInput.addEventListener('input', () => {
    codeInput.value = codeInput.value.replace(/\D/g, '');
    if (codeInput.value.length === 6) {
      form.dispatchEvent(new Event('submit'));
    }
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const code = codeInput.value.trim();
    if (code.length !== 6) return;

    const btn = form.querySelector('button')!;
    btn.disabled = true;
    btn.textContent = 'Verifying...';

    try {
      const response = await authApi.verify(currentEmail, code);
      const { accessToken, refreshToken, isNewUser } = response.data;

      store.setTokens(accessToken, refreshToken);
      isVerifyMode = false;
      currentEmail = '';

      // Reset app class
      const app = document.getElementById('app')!;
      app.className = '';

      // Load user data and connect socket
      await loadUserData();
      connectSocket();
      import('../push').then(m => m.initPush()).catch(() => {});

      // Navigate to onboarding if new user, otherwise discover
      if (isNewUser) {
        navigate('/onboarding');
      } else {
        navigate('/browse');
      }
    } catch (err: any) {
      showToast(TOAST_CODE_INVALID, 'error');
      btn.disabled = false;
      btn.textContent = 'Verify';
      codeInput.value = '';
      codeInput.focus();
    }
  });

  backBtn.addEventListener('click', () => {
    isVerifyMode = false;
    isNewUserSignup = false;
    currentEmail = '';
    if (returnTo === 'welcome') {
      renderWelcome();
    } else if (returnTo === 'welcome2') {
      renderWelcome2();
    } else {
      renderLogin();
    }
  });

  codeInput.focus();
}
